export const isLocalEnv = process.env.NODE_ENV === 'development';
export const urlBase = isLocalEnv ? '' :
    'https://remingtonseeds.seedbin.com';

export default {
    isLocalEnv,
    urlBase
}